export const _tsMimeTypes = ["video/vnd.dlna.mpeg-tts"];
